import { Container } from "../Container"
import { ParallaxBanner } from "react-scroll-parallax"
import styles from "./Hero.module.css"

export const Hero = () => {
  return (
    <ParallaxBanner
      layers={[
        {
          image:
            "https://portfolio-demos-1.s3.eu-west-2.amazonaws.com/stars.jpg",
          speed: 40,
        },
        {
          image:
            "https://portfolio-demos-1.s3.eu-west-2.amazonaws.com/bgmount.png",
          speed: -10,
          translateY: [0, 0.2],
          scale: [1, 1.2, "easeOutCubic"],
          shouldAlwaysCompleteAnimation: true,
        },
      ]}
      className={styles.banner}
    >
      <section className={styles.root}>
        <Container>
          <div className={styles.text}>
            <h1>Senior Frontend Software Engineer (TypeScript / React)</h1>
            <p>
              I am a results-driven software engineer with experience across
              SaaS, PaaS, Gaming, Consultancy and Agency environments.
            </p>
          </div>
        </Container>
      </section>
    </ParallaxBanner>
  )
}
